import { createApp, type App } from "vue"
import CustomerWidget from "./App.vue"
import { VueFire, VueFireAuth } from "vuefire"
import { firebaseApp } from "./firebase"
// Tailwind 스타일 인라인 임포트 제거
// import tailwindStyles from './styles/main.css?inline';

// 전역 네임스페이스 및 init 함수 제거됨

let appInstance: App | null = null

// --- 설정 로딩 함수 ---
function loadSettingsFromScript() {
  // 현재 스크립트 태그나 data 속성이 있는 스크립트 태그 찾기
  const scriptTag =
    document.currentScript ||
    document.querySelector("script[data-wowpress-widget]") ||
    document.querySelector('script[src*="chatbot-widget.js"]')

  if (scriptTag) {
    console.log("[Wowpress Widget] Found script tag with settings:", scriptTag)

    // data 속성들을 전역 변수로 설정 (useWidgetSettings에서 읽을 수 있도록)
    if (!window.wowpressWidgetConfig) {
      window.wowpressWidgetConfig = {}
    }

    // 실제 사용되는 data 속성만 추출
    const position = scriptTag.getAttribute("data-position")
    const promoText = scriptTag.getAttribute("data-promo-text")

    // null이 아닌 값들만 저장
    if (position) window.wowpressWidgetConfig.position = position
    if (promoText) window.wowpressWidgetConfig.promoText = promoText

    console.log("[Wowpress Widget] Loaded config:", window.wowpressWidgetConfig)
  }
}

// --- 컨테이너 생성 또는 찾기 ---
function ensureContainer() {
  const selector = "#wowpress-widget-container"
  let container = document.querySelector(selector)

  if (!container) {
    console.log("[Wowpress Widget] Container not found, creating one...")
    container = document.createElement("div")
    container.id = "wowpress-widget-container"
    document.body.appendChild(container)
  }

  return container
}

// --- 위젯 초기화 함수 ---
function initializeWidget() {
  if (appInstance) {
    console.warn("[Wowpress Widget] Already initialized. Skipping.")
    return
  }

  // 설정 로딩
  loadSettingsFromScript()

  // 컨테이너 확보
  const hostElement = ensureContainer()

  console.log(`[Wowpress Widget] Initializing Vue app in container`)

  // Vue 앱 인스턴스 생성 및 설정
  appInstance = createApp(CustomerWidget)
  appInstance.use(VueFire, {
    firebaseApp,
    modules: [VueFireAuth()],
  })

  // Vue 앱 마운트
  try {
    appInstance.mount(hostElement)
    console.log("[Wowpress Widget] Vue app mounted successfully.")

    // 부모 페이지에 위젯 준비 완료 알림
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: "WIDGET_READY" }, "*")
    }
  } catch (mountError) {
    console.error("[Wowpress Widget] Failed to mount Vue app:", mountError)
    appInstance = null
  }
}

// 전역 타입 확장
declare global {
  interface Window {
    wowpressWidgetConfig?: any
  }
}

// DOM 로드 완료 후 초기화
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeWidget)
} else {
  // 약간의 지연을 주어 스크립트 태그가 완전히 로드되도록 함
  setTimeout(initializeWidget, 0)
}

// 이전: console.log('[Wowpress Widget] Main script loaded. Ready to initialize via window.WowpressWidget.init()');
console.log("[Wowpress Widget] Script loaded and initialization scheduled.")

// 자동 초기화는 로더(widget-loader.ts)에서 처리하므로 여기서는 제거
